import { render } from "./typeQlrUse.vue?vue&type=template&id=5b6eaef3"
import script from "./typeQlrUse.vue?vue&type=script&lang=js"
export * from "./typeQlrUse.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__